/**
 * Small Island Wines — consent evidence.
 *
 * Writes the human-readable evidence record into contact[note] at submit time, so the
 * customer record carries the wording that was actually on screen rather than whatever
 * the wording happens to be whenever someone next looks.
 *
 * Everything here is additive. The consent state itself is carried by the
 * contact[accepts_marketing] checkbox, which Shopify records natively with its own
 * timestamp — if this script never runs, the consent is still recorded correctly and
 * only the free-text corroboration is missing.
 */
(() => {
  const blocks = document.querySelectorAll('[data-siw-consent]');
  if (!blocks.length) return;

  for (const block of blocks) {
    const box = block.querySelector('[data-siw-consent-box]');
    const note = block.querySelector('[data-siw-consent-note]');
    const text = block.querySelector('[data-siw-consent-text]');
    const form = block.closest('form');
    if (!box || !note || !form) continue;

    form.addEventListener('submit', () => {
      // Only record evidence when they actually said yes. An unticked box is not a
      // consent record and must not leave a note implying one.
      if (!box.checked) {
        note.value = '';
        return;
      }

      const wording = (text?.textContent || '').trim().replace(/\s+/g, ' ');
      note.value = [
        'Marketing consent given at signup.',
        `Source: ${box.dataset.siwConsentSource || 'unknown'}`,
        `Notice version: ${box.dataset.siwConsentVersion || 'v1'}`,
        `Page: ${window.location.pathname}`,
        `Timestamp: ${new Date().toISOString()}`,
        `Wording shown: "${wording}"`,
      ].join(' | ');
    });
  }
})();
